import React from 'react';
import { useAuth } from '../../../providers/auth-provider';

function LeaderDevelopmentTipsIntro() {
  const { clientDisplayName } = useAuth();

  return (
    <div>
      {clientDisplayName} is a strong believer in developing individuals across the organization. As such, you can find
      some proven developmental tips below to help you in your role. These action tips are based on the assessments that
      you completed as part of the development process. The recommendations included in this report are targeted tips
      that can be applied to your current role and/or any role in your future.
    </div>
  );
}

export default LeaderDevelopmentTipsIntro;
